import { Grid } from '@mui/material';
import { update } from 'lodash';
import { EMPTY_ANIMATION_DATA } from 'src/constants';
import { AnimationTypeKeys, AnimationTypes, IAnimation } from 'src/interfaces';

import { StyledTabPanel } from '../../ProductAnimationAccordion.styled';
import { AnimationStyleSelector } from '../animationStyleSelector/AnimationStyleSelector';
import { FrameRangeSelector } from '../frameRangeSelector/FrameRangeSelector';
import { ANIMATIONS_DATA } from './ElementsTabPanel.constants';
import { IElementsTabPanelProps } from './ElementsTabPanel.interface';

export const ElementsTabPanel = ({
  animation,
  onChange,
}: IElementsTabPanelProps) => {
  const handleOnChange = (path: string, value: unknown) => {
    const { delay } = value as any;

    const updatedAnimation = update(
      JSON.parse(JSON.stringify(animation || EMPTY_ANIMATION_DATA)),
      path,
      () => (delay === undefined ? null : value),
    );
    onChange(updatedAnimation);
  };

  return (
    <StyledTabPanel value={AnimationTypeKeys.ELEMENTS}>
      <Grid container gap={2} direction="column">
        <AnimationStyleSelector />
        {ANIMATIONS_DATA.map(({ id, label, key }) => {
          if (!animation || !animation[key]) return null;

          const animatedItem = animation[key] as IAnimation;

          return (
            <FrameRangeSelector
              id={id}
              label={label}
              startFrame={animatedItem.in?.delay || 0}
              endFrame={animatedItem.out?.delay}
              onStartFrameChange={(ms) => {
                handleOnChange(`${key}.in`, {
                  ...animatedItem.in,
                  delay: ms || 0,
                  type: AnimationTypes.FADE,
                });
              }}
              onEndFrameChange={(ms) => {
                handleOnChange(`${key}.out`, {
                  ...animatedItem.out,
                  delay: ms,
                  type: AnimationTypes.FADE,
                });
              }}
            />
          );
        })}
      </Grid>
    </StyledTabPanel>
  );
};
